import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {CloseTabComponent} from './containers/close-tab/close-tab.component';
import {ClosedTabModalComponent} from './components/closed-tab-modal/closed-tab-modal.component';

const routes: Routes = [
  { path: '', component: CloseTabComponent }
];

@NgModule({
  declarations: [CloseTabComponent, ClosedTabModalComponent],
  imports: [CommonModule, RouterModule.forChild(routes), IonicModule, SharedModule]
})
export class CloseTabPageModule {}
